import { type Theme } from '@mui/material/styles';

export const getHopColor = (latencies: string[], theme: Theme) => {
  if (latencies.every((lat) => lat === '*'))
    return theme.palette.traceroute.failed;
  if (latencies.some((lat) => lat === '*'))
    return theme.palette.traceroute.partial;
  if (latencies.some((lat) => parseInt(lat) > 100))
    return theme.palette.traceroute.attention;
  return theme.palette.traceroute.good;
};
